import Box from '@mui/material/Box';

/**
 * The platform logo mark (`public/logo.svg`), sized for inline brand rows next
 * to the brand name. The adjacent text carries the name, so the image itself is
 * decorative (empty alt). Vite serves `/logo.svg` from `public/` in dev and out
 * of `dist/` in the single-container deployment.
 */
export function BrandLogo({ height = 26 }: { height?: number }) {
  return (
    <Box
      component="img"
      src="/logo.svg"
      alt=""
      sx={{ height, width: 'auto', display: 'block', flexShrink: 0 }}
    />
  );
}
